export const PKG_NAME = "@hpcc-js/common";
export const PKG_VERSION = "2.73.6";
export const BUILD_VERSION = "2.108.11";
